import { FETCH_LOCATIONS } from '../constants/action-types';
export const fetchLocations = () => ({
    type: FETCH_LOCATIONS,
});
